import { initialState } from './initial';
import { actionTypes } from './actions';

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.ACTION_PROCESSING:
      return { ...state, actionProcessing: action.payload };

    case actionTypes.SET_IS_PROCESS:
      return { ...state, isProcess: action.payload };

    case actionTypes.LOGOUT:
      return { ...initialState, loginFailedAttempts: state.loginFailedAttempts };
    case actionTypes.SIGN_IN_SUCCESS:
      return { ...state, maxDeposit: null, ...action.payload, isAuth: true };
    case actionTypes.GET_BALANCE:
      return { ...state, ...action.payload };
    case actionTypes.GET_NOTIFICATIONS:
      const hiddenNotifications = JSON.parse(localStorage.getItem('hiddenNotifications') || '[]');

      const filteredNotifications = action.payload?.filter(({ id }) => !hiddenNotifications.includes(id));
      return { ...state, notifications: filteredNotifications };
    case actionTypes.SEEND_NOTIFICATIONS:
      return { ...state, seendNotifications: action.payload };
    case actionTypes.REMOVE_SEEND_NOTIFICATIONS:
      return { ...state, seendNotifications: action.payload };

    case actionTypes.CHANGE_LOGIN_ATTEMPTS:
      return { ...state, loginFailedAttempts: action.payload ?? state.loginFailedAttempts + 1 };

    case actionTypes.SET_SEMI_AUTO_WITHDRAWAL_ENABLED:
      return { ...state, semiAutoWithdrawalEnabled: action.payload };

    case actionTypes.GET_METADATA:
      return { ...state, ...action.payload };

    case actionTypes.SET_IS_HIGHER_AGENTS_OPERATIONS_RESTRICTED:
      return { ...state, isHigherAgentsOperationsRestricted: action.payload };

    default:
      return state;
  }
};
